import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25234c09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-autocomplete-wrapper" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_autocomplete_text_input = _resolveComponent("oxd-autocomplete-text-input")!
  const _component_oxd_autocomplete_option = _resolveComponent("oxd-autocomplete-option")!
  const _component_oxd_autocomplete_dropdown = _resolveComponent("oxd-autocomplete-dropdown")!
  const _component_oxd_autocomplete_chips = _resolveComponent("oxd-autocomplete-chips")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_oxd_autocomplete_text_input, _mergeProps(_ctx.$attrs, {
      clear: _ctx.showClear,
      placeholder: _ctx.placeholderText,
      value: _ctx.inputValue,
      disabled: _ctx.disabled,
      readonly: _ctx.readonly,
      onBlur: _ctx.onBlur,
      onInput: _ctx.onSearch,
      onClear: _ctx.onClear,
      onKeyup: _withKeys(_ctx.onCloseDropdown, ["esc"]),
      onKeydown: [
        _withKeys(_withModifiers(_ctx.onSelectEnter, ["prevent"]), ["enter"]),
        _withKeys(_withModifiers(_ctx.onSelectDown, ["exact","prevent"]), ["down"]),
        _withKeys(_withModifiers(_ctx.onSelectUp, ["exact","prevent"]), ["up"])
      ]
    }), {
      beforeInput: _withCtx(() => [
        (!_ctx.multiple && _ctx.modelValue)
          ? _renderSlot(_ctx.$slots, "beforeSelected", {
              key: 0,
              data: _ctx.modelValue
            }, undefined, true)
          : _createCommentVNode("", true)
      ]),
      afterInput: _withCtx(() => [
        (!_ctx.multiple && _ctx.modelValue)
          ? _renderSlot(_ctx.$slots, "afterSelected", {
              key: 0,
              data: _ctx.modelValue
            }, undefined, true)
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 16, ["clear", "placeholder", "value", "disabled", "readonly", "onBlur", "onInput", "onClear", "onKeyup", "onKeydown"]),
    (_ctx.dropdownOpen)
      ? (_openBlock(), _createBlock(_component_oxd_autocomplete_dropdown, {
          key: 0,
          class: _normalizeClass(_ctx.dropdownClasses),
          loading: _ctx.loading,
          empty: _ctx.computedOptions.length === 0
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedOptions, (option, i) => {
              return (_openBlock(), _createBlock(_component_oxd_autocomplete_option, {
                key: option.id,
                class: _normalizeClass(_ctx.optionClasses[i]),
                disabled: option._disabled || option._selected,
                onSelect: ($event: any) => (_ctx.onSelect(option))
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "option", {
                    data: option,
                    text: _ctx.highlightedOptions[i]
                  }, undefined, true),
                  (!_ctx.$slots['option'])
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        innerHTML: _ctx.highlightedOptions[i]
                      }, null, 8, _hoisted_2))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["class", "disabled", "onSelect"]))
            }), 128))
          ]),
          _: 3
        }, 8, ["class", "loading", "empty"]))
      : _createCommentVNode("", true),
    (_ctx.multiple)
      ? (_openBlock(), _createBlock(_component_oxd_autocomplete_chips, {
          key: 1,
          disabled: _ctx.disabled,
          readonly: _ctx.readonly,
          selected: _ctx.modelValue,
          onChipRemoved: _ctx.onRemoveSelected
        }, null, 8, ["disabled", "readonly", "selected", "onChipRemoved"]))
      : _createCommentVNode("", true)
  ]))
}